export const SET_SECTOR_ARRAY = "SET_SECTOR_ARRAY";
export const SET_INDUSTRY_ARRAY = "SET_INDUSTRY_ARRAY";
export const SET_SECTOR_INDUSTRIES_TREE = "SET_SECTOR_INDUSTRIES_TREE";
